import axios from "axios";

const api = axios.create({
    // baseURL: "http://localhost/grit/api/",
    baseURL: "https://griteam.ir/api/",
    timeout: 10000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response) {
            return error.response;
        }
        return Promise.reject(error);
    }
);

export default api;